import {useEffect} from "react";

import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import {ThemeProvider} from '@mui/material/styles';

import {getAnalytics, logEvent} from "firebase/analytics";

import ContactUs from "../components/ContactUs";
import MenuButton from "../components/MenuButton";
import Welcome from "../components/Welcome";
import Divider from "../../../components/common/Divider";

import {dizengoffMommiesTheme} from "../../../theme/theme";
import ImageSlider from "../components/ImageSlider";
import Typography from "@mui/material/Typography";

function About() {
    useEffect(() => {
        logEvent(getAnalytics(), 'dizengoff_mommies');
    }, []);

    return (
        <ThemeProvider theme={dizengoffMommiesTheme}>
            <CssBaseline/>
            <Box
                display={"flex"}
                flexDirection={"column"}
                sx={{
                    width: "100%",
                    maxWidth: "100vw", // Prevents the Box from exceeding the viewport width
                    overflowX: "hidden",
                }}
            >
                <MenuButton/>
                <Welcome/>

                <Box
                    p={8}
                >
                    <Typography
                        variant={"h6"}
                        sx={{
                            fontWeight: "600",
                            pt: 1,
                            pb: 1
                        }}
                    >
                        אני הודיה פנסאפורקאר, קלינאית תקשורת לילדים.
                    </Typography>
                    <Typography
                        variant={"h6"}
                        sx={{
                            fontWeight: "600",
                            pt: 1,
                            pb: 1
                        }}
                    >
                        את Dizengoff Mommies הקמתי מתוך רצון ליצור מרחב רגוע, אמין ומבוסס ידע – מקום שבו אימהות יכולות ללמוד, לשאול, להרגיש בטוחות ולקבל מענה בשלב כל כך משמעותי בחיים.
                    </Typography>
                    <Typography
                        variant={"h6"}
                        sx={{
                            fontWeight: "600",
                            pt: 1,
                            pb: 1
                        }}
                    >
                        במפגשים שלנו תמצאו סדנאות והרצאות מקצועיות עם מטפלות מוסמכות ובעלות ניסיון קליני משמעותי – לצד נשנושים מפנקים ואווירה נעימה.
                    </Typography>
                    <Typography
                        variant={"h6"}
                        sx={{
                            fontWeight: "600",
                            pt: 1,
                            pb: 1
                        }}
                    >
                        כל מפגש הוא הזדמנות נפלאה ללמוד, להתחבר – ולהתמלא בהשראה.
                    </Typography>
                </Box>

                <ImageSlider/>
                <Divider/>
                <ContactUs/>
            </Box>
        </ThemeProvider>
    );
}

export default About;
